// extracted by mini-css-extract-plugin
module.exports = {"priceLevelDisplay":"PriceLevelDisplay_priceLevelDisplay__ZoqZq","priceLevelDisplayDefault":"PriceLevelDisplay_priceLevelDisplayDefault__U5oVp"};